<template>
  <div>
    <div class="modal-backdrop fade"></div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated show" id="onboardingWideFormModal" role="dialog" tabindex="-1" style="display: block;">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Image Preview</h5>
            <button aria-label="Close" class="close" @click="closeModal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div class="modal-body" style="text-align: center">
            <v-zoomer>
             <img :src="formatImage(imgSource)" height="500px" />
            </v-zoomer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['show', 'type'],
  data () {
    return {
      content: ''
    }
  },
  created() {
    const onEscape = (e) => {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    }
    document.addEventListener('keydown', onEscape)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape)
    })
  },
  methods: {
    formatImage: function (image) {
      if (
        image &&
        image.retouch_location != null &&
        this.sourceType &&
        this.sourceType == 'retouch'
      ) {
        return image.host_retouch + image.retouch_location
      } else if (image && image.raw_thumb_location != null) {
        return image.host + image.raw_thumb_location
      } else {
        return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }
    },

    // formatImage: function(image) {
    //   return (
    //     (image && image.host + image.raw_thumb_location) ||
    //     "https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png"
    //   );
    // },
    closeModal () {
      var context = {
        content: 'image',
        contentType: '',
        show: false
      }
      this.$store.dispatch('updateModal', context)
    }
  },
  computed: {
    imgSource () {
      return this.$store.getters.modalSettings.content
    },
    sourceType () {
      return this.$store.getters.modalSettings.type
    }
  }
}
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css";
</style>
